import axios from "axios"
import { singleton, inject } from "tsyringe"
export interface IWebinarDataService {
  setUp(
    publishWebinarDataEndPoint: string,
    queryEndpoint: string,
    data: object
  ): void
  getData(filename: string): Promise<unknown>
}
export class ApiDataService implements IWebinarDataService {
  private PublishedWebinarDataEndPoint = ""
  private filename = ""
  private queryEndpoint = ""
  private data = {}
  setUp(
    publishWebinarDataEndPoint: string,
    queryEndpoint: string = "",
    data: object = {}
  ) {
    this.PublishedWebinarDataEndPoint = publishWebinarDataEndPoint
    this.queryEndpoint = queryEndpoint
    this.data = data
  }
  getData(filename: string) {
    if (!filename)
      return new Promise(function (resolve, reject) {
        return resolve(undefined)
      })
    const url = !this.queryEndpoint
      ? `${this.PublishedWebinarDataEndPoint}${filename}.json`
      : `${this.PublishedWebinarDataEndPoint}${filename}.json${this.queryEndpoint}`
    return axios
      .get(url)
      .then(async function (response) {
        //await wait(1000)
        return response.data
      })
      .catch(function (error) {
        console.error(error)
        return undefined
      })
  }
}
export class OptionDataService implements IWebinarDataService {
  private PublishedWebinarDataEndPoint = ""
  private filename = ""
  private queryEndpoint = ""
  private data = {}
  setUp(
    publishWebinarDataEndPoint: string,
    queryEndpoint: string = "",
    data: object
  ) {
    this.PublishedWebinarDataEndPoint = publishWebinarDataEndPoint
    this.queryEndpoint = queryEndpoint
    this.data = data
  }
  getData(filename: string) {
    const self = this
    return new Promise(function (resolve, reject) {
      return resolve(self.data)
    })
  }
}
@singleton()
export class WebinarDataService {
  private _client: IWebinarDataService
  constructor(
    @inject("WebinarDataService") public client: IWebinarDataService
  ) {
    this._client = client
  }
  public setUp(
    publishWebinarDataEndPoint: string,
    queryEndpoint: string = "",
    data: object
  ) {
    this._client.setUp(publishWebinarDataEndPoint, queryEndpoint, data)
  }
  public getData(filename: string = ""): Promise<unknown> {
    return this._client.getData(filename)
  }
}
